import React, { useState } from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { updateHabit } from "../features/Habit/HabitSlice";
import IUpdateHabit from "../features/Habit/interfaces/IUpdateHabit";
import "../styles/components/edit-habit.scss";
import CustomButton from "./CustomButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

interface UpdateProps {
  habitId: number;
}

const UpdateHabit: React.FC<UpdateProps> = ({ habitId }: UpdateProps) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const [updateHabitData, setUpdateHabitData] = useState<IUpdateHabit>({
    habit_id: habitId,
    habit_description: "",
    habit_name: "",
  });

  return (
    <>
      <CustomButton
        className="edit-button"
        onClick={handleOpen}
        variant="text"
        style={{
          backgroundColor: "white",
          border: "2px solid black",
          color: "black",
        }}
        displayText="Edit Habit"
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="edit-habit-modal"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
          className="box"
        >
          <TextField
            label="Habit name"
            required
            onChange={(e) => {
              setUpdateHabitData((prev) => ({
                ...prev,
                habit_name: e.target.value,
              }));
            }}
            style={{ width: "100%" }}
            className="edit--habit-name"
          />
          <TextField
            label="Habit description"
            onChange={(e) => {
              setUpdateHabitData((prev) => ({
                ...prev,
                habit_description: e.target.value,
              }));
            }}
            className="edit--habit-description"
            style={{ width: "100%" }}
          />
          <Button
            variant="text"
            style={{
              backgroundColor: "white",
              width: "40%",
              border: "2px solid black",
              color: "black",
            }}
            onClick={async () => {
              const output = (await dispatch(
                updateHabit(updateHabitData)
              )) as any;
              if (output?.type === "habit/updateHabit/fulfilled") {
                handleClose();
                history.push("/empty");
                history.goBack();
              }
            }}
            className="button"
          >
            Submit
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default UpdateHabit;
